(function () {
    function SoliaPage() {
        return (React.createElement("div", null,
            React.createElement(StoryHero, null),
            React.createElement(StoryOrigin, null),
            React.createElement(StoryPhilosophy, null),
            React.createElement(StoryClose, { shopHref: "/pages/shop" })));
    }
    ReactDOM.createRoot(document.getElementById('solia-our-story-root')).render(React.createElement(SoliaPage, null));
})();
